// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__BMyM-","search":"Settings_search__3TN1Z","filter":"Settings_filter__3VAmi"};